import { createContext, useCallback, useContext } from 'react';

import { useKey, useToggle, useUpdateEffect } from 'ui/hooks';

import type { DrawerStackContext } from './StackNavigatorProvider.d';

export const DrawerContext = createContext({} as DrawerStackContext);

export const useDrawer = () => {
  const value = useContext(DrawerContext);

  return value;
};

export const useDrawerEventListeners = (hasOpenDrawers: boolean, closeAllDrawers: () => void) => {
  const handleCloseDrawers = useCallback(() => {
    if (hasOpenDrawers) {
      closeAllDrawers();
    }
  }, [hasOpenDrawers, closeAllDrawers]);

  useKey('Escape', handleCloseDrawers, { event: 'keyup' }, [handleCloseDrawers]);
};

export const useToggleDrawer = (initialValue = false) => {
  const [on, toggle] = useToggle(initialValue);
  const { hasOpenDrawers } = useDrawer();
  const isOpen = on;

  const toggleDrawer = (forcedValue?: boolean) => {
    const value = forcedValue || !on;

    toggle(value);
  };

  useUpdateEffect(() => {
    if (!hasOpenDrawers) {
      toggle(false);
    }
  }, [hasOpenDrawers, toggle]);

  return { isOpen, toggleDrawer };
};
